export default "__VITE_ASSET__xMxJZmOh__"